module.exports = __webpack_public_path__ + "static/favicon-90b4553a1ffd617a47b1c8780be287da.ico";